import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Tier } from '../models';
import { NamedEntity } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class GlobalEventsService {
  private _tiersChanged = new Subject<void>();
  private _pendingChangesUpdated = new Subject<void>();
  private _selectedTier = new BehaviorSubject<Tier | null>(null);
  private _selectedConcept = new BehaviorSubject<NamedEntity | null>(null);
  private _tierSelectorVisible = new BehaviorSubject<number>(0);
  private _navigatedAwayFromLTO = new Subject<void>();
  private _navigatedAwayFromSyncHistory = new Subject<void>();
  tiersChanged$ = this._tiersChanged.asObservable();
  pendingChangesUpdated$ = this._pendingChangesUpdated.asObservable();
  selectedTier$ = this._selectedTier.asObservable();
  selectedConcept$ = this._selectedConcept.asObservable();
  tierSelectorVisible$ = this._tierSelectorVisible.asObservable();
  navigatedAwayFromLTO$ = this._navigatedAwayFromLTO.asObservable();
  navigatedAwayFromSyncHistory$ = this._navigatedAwayFromSyncHistory.asObservable();

  updateTiers() {
    this._tiersChanged.next();
  }

  updateSelectedTier(tier: Tier) {
    this._selectedTier.next(tier);
  }

  updateSelectedConcept(concept: NamedEntity) {
    this._selectedConcept.next(concept);
  }

  getSelectedTier() {
    return this._selectedTier.value;
  }

  showTierSelector() {
    this._tierSelectorVisible.next(this._tierSelectorVisible.value + 1);
  }

  hideTierSelector() {
    this._tierSelectorVisible.next(this._tierSelectorVisible.value - 1);
  }

  onNavigateAwayFromLTO() {
    this._navigatedAwayFromLTO.next();
  }

  onNavigateAwayFromSyncHistory() {
    this._navigatedAwayFromSyncHistory.next();
  }

  updatePendingChanges() {
    this._pendingChangesUpdated.next();
  }
}
